(function ($, Drupal, drupalSettings) {
  "use strict";

  $(document).ready(function () {
    if (
      $(".checkout-pane-rkpt-review-fields .form-item-rkpt-review-fields-terms")
        .length > 0
    ) {
      if (
        !$(
          '.checkout-pane-rkpt-review-fields .form-item-rkpt-review-fields-terms input[type="checkbox"]',
        ).prop("checked")
      ) {
        if (
          $(
            ".commerce-checkout-flow .layout-checkout-form .paypal-buttons-container",
          ).length > 0
        ) {
          $(
            ".commerce-checkout-flow .layout-checkout-form .paypal-buttons-container",
          ).removeClass("show-buttons");
          if (
            $(".commerce-checkout-flow .layout-checkout-form .form-actions")
              .length < 1
          ) {
            $(".link--previous").wrap("<div class='form-actions'></div>");
          }
          $(
            '<div class="pseudo-button button button--primary js-form-submit form-submit">Ολοκλήρωση</div>',
          ).insertBefore(
            ".commerce-checkout-flow .layout-checkout-form .link--previous",
          );
        }
      } else {
        if (
          $(
            ".commerce-checkout-flow .layout-checkout-form .paypal-buttons-container",
          ).length > 0
        ) {
          $(
            ".commerce-checkout-flow .layout-checkout-form .paypal-buttons-container",
          ).addClass("show-buttons");
          $(
            ".commerce-checkout-flow .layout-checkout-form .pseudo-button",
          ).remove();
        }
      }

      $(document).on(
        "click",
        ".commerce-checkout-flow .layout-checkout-form .layout-region-checkout-footer .form-actions .button--primary",
        function (event) {
          if (
            !$(
              '.checkout-pane-rkpt-review-fields .form-item-rkpt-review-fields-terms input[type="checkbox"]',
            ).prop("checked")
          ) {
            event.preventDefault();
            $(
              ".checkout-pane-rkpt-review-fields .form-item-rkpt-review-fields-terms",
            ).addClass("error");

            var descriptionElement =
              "<div class='error-message'>Το πεδίο είναι υποχρεωτικό.</div>";
            $(".form-item-rkpt-review-fields-terms").append(descriptionElement);
          }
        },
      );
    }

    $(document).on(
      "change",
      '.layout-region-checkout-main .form-item-rkpt-review-fields-terms input[type="checkbox"]',
      function () {
        if ($(this).prop("checked")) {
          $(this)
            .closest(".form-item-rkpt-review-fields-terms")
            .removeClass("error");
          $(".form-item-rkpt-review-fields-terms .error-message").remove();

          if (
            $(
              ".commerce-checkout-flow .layout-checkout-form .paypal-buttons-container",
            ).length > 0
          ) {
            $(
              ".commerce-checkout-flow .layout-checkout-form .paypal-buttons-container",
            ).addClass("show-buttons");
            $(
              ".commerce-checkout-flow .layout-checkout-form .pseudo-button",
            ).remove();
          }
        } else {
          if (
            $(
              ".commerce-checkout-flow .layout-checkout-form .paypal-buttons-container",
            ).length > 0
          ) {
            if (
              $(".commerce-checkout-flow .layout-checkout-form .form-actions")
                .length < 1
            ) {
              $(".link--previous").wrap("<div class='form-actions'></div>");
            }
            $(
              ".commerce-checkout-flow .layout-checkout-form .paypal-buttons-container",
            ).removeClass("show-buttons");
            $(
              '<div class="pseudo-button button button--primary js-form-submit form-submit">Ολοκλήρωση</div>',
            ).insertBefore(
              ".commerce-checkout-flow .layout-checkout-form .link--previous",
            );
          }
        }
      },
    );
  });

  $(document).on(
    "click",
    ".commerce-checkout-flow .layout-checkout-form .pseudo-button",
    function (event) {
      if (
        !$(
          '.checkout-pane-rkpt-review-fields .form-item-rkpt-review-fields-terms input[type="checkbox"]',
        ).prop("checked")
      ) {
        event.preventDefault();
        $(
          ".checkout-pane-rkpt-review-fields .form-item-rkpt-review-fields-terms",
        ).addClass("error");

        var descriptionElement =
          "<div class='error-message'>Το πεδίο είναι υποχρεωτικό.</div>";
        $(".form-item-rkpt-review-fields-terms").append(descriptionElement);
      }
    },
  );

  /**
   * Adds a close button to the message.
   *
   * @param {object} message
   *   The message object.
   */
  const closeMessage = (message) => {
    const messageContainer = message.querySelector(".messages");
    const theKid = document.createElement("a");
    theKid.setAttribute("href", "#");
    theKid.classList.add("messageclose");
    theKid.setAttribute("title", "Close");
    theKid.innerHTML = "&times;";
    message.insertBefore(theKid, message.firstChild);

    theKid.addEventListener("click", (e) => {
      e.preventDefault();
      fadeOutEffect(message);
    });
  };

  /**
   * Fade-out effect to element.
   *
   * @param {object} fadeTarget
   *   The fade target.
   */
  const fadeOutEffect = (fadeTarget) => {
    var fadeEffect = setInterval(function () {
      if (!fadeTarget.style.opacity) {
        fadeTarget.style.opacity = 1;
      }
      if (fadeTarget.style.opacity > 0) {
        fadeTarget.style.opacity -= 0.1;
      } else {
        clearInterval(fadeEffect);
        fadeTarget.classList.add("hidden");
      }
    }, 20);
  };

  /**
   * Get messages from context.
   *
   * @type {Drupal~behavior}
   *
   * @prop {Drupal~behaviorAttach} attach
   *   Attaches the messageclose button behavior for messages.
   */
  Drupal.behaviors.messageclose = {
    attach(context) {
      once("messageclose", ".messages", context).forEach(closeMessage);
    },
  };

  function removeGreekAccents(text) {
    const accentsMap = {
      ά: "α",
      έ: "ε",
      ή: "η",
      ί: "ι",
      ό: "ο",
      ύ: "υ",
      ώ: "ω",
    };
    return text.replace(/[άέήίόύώ]/g, (match) => accentsMap[match] || match);
  }

  $(document).on("mousedown", ".js-form-type-select", function (e) {
    const $selector = $(this);
    const $select = $selector.find("select");

    const $existingDropDown = $selector.find(".selector-options");
    if ($existingDropDown.length > 0) {
      e.preventDefault();
      $selector.removeClass("open");
      $existingDropDown.remove();
      return;
    }

    if (window.innerWidth > 768) {
      e.preventDefault();
      const $dropDown = $('<ul class="selector-options"></ul>');
      $selector.addClass("open");

      const $options = $select.children().filter(function () {
        const value = $(this).val();
        return value !== "" && value !== "none" && !$(this).is(":selected");
      });
      if ($options.length > 4) {
        const $searchInput = $(
          '<input type="text" class="selector-search" placeholder="Search...">',
        );
        $searchInput.on("mousedown", function (e) {
          e.stopPropagation();
        });
        $searchInput.on("input", function () {
          const searchText = removeGreekAccents($(this).val().toLowerCase());
          $dropDown.find("li").each(function () {
            const $option = $(this);
            const optionText = removeGreekAccents($option.text().toLowerCase());
            if (optionText.includes(searchText)) {
              $option.show();
            } else {
              $option.hide();
            }
          });
        });
        $dropDown.append($searchInput);
      }

      $options.each(function () {
        const $option = $(this);
        const $dropDownOption = $("<li></li>").text($option.text());
        $dropDownOption.appendTo($dropDown);

        $dropDownOption.on("mousedown", function (e) {
          e.stopPropagation();
          $select.val($option.val());
          $selector.val($option.val());
          $select.trigger("change");
          $selector.trigger("change");
          $selector.find(".selector-options").remove();
          $select.off("click"); // Turn off the click event listener on the select
        });
      });

      $selector.append($dropDown);

      $select.on("click", function (e) {
        e.stopPropagation();
      });
    }
  });

  if ($(".js-form-type-select").length > 0) {
    $(document).on("click", function (e) {
      e.stopPropagation();
      $(".js-form-type-select").each(function () {
        const $selector = $(this);
        if (
          !$selector.is(e.target) &&
          !$selector.find(".selector-search").is(e.target) &&
          $selector.has(e.target).length === 0
        ) {
          $selector.removeClass("open");
          $selector.find(".selector-options").remove();
        }
      });
    });
  }

  $(document).on("keydown", function (e) {
    if (e.which === 27) {
      $(".selector-options").remove();
    }
  });

  /* 
  | ----------------------------
  | Header 
  | ----------------------------
  */
  var headerHeight, menuHeight;
  menuHeight = $("header").outerHeight();

  if ($("body").hasClass("user-logged-in")) {
    headerHeight = $("header").outerHeight() + 20 + "px";
  } else {
    var headerHeight = $("header").outerHeight() - 2 + "px";
  }

  if ($(window).width() <= 768) {
    $(".navigation-region").css("top", menuHeight - 30 + "px");
    $("nav.anchor-menu").css("top", menuHeight - 1 + "px");

    $(".search-results-container").css("top", menuHeight + 60 + "px");
  } else {
    $(".navigation-region").css("top", menuHeight - 14 + "px");
    // $(".navigation-region .menu-main li.menu-item--expanded .menu-level-1").css(
    //   "top",
    //   menuHeight - 14 + "px"
    // );

    $("nav.anchor-menu").css("top", menuHeight - 1 + "px");
    $(".search-results-container").css("top", menuHeight - 14 + "px");
  }

  if ($(window).width() >= 1024) {
    $(function ($) {
      $(
        ".menu-level-0 > .menu-item--expanded > a, .menu-level-0 > .menu-item--expanded > span",
      ).on("click", function (e) {
        e.preventDefault();
        let $parent = $(this).parent();

        $(".menu-item--expanded").not($parent).removeClass("open");

        $parent.toggleClass("open");
      });

      $(document).on("click", function (e) {
        if (!$(e.target).closest(".menu-main").length) {
          $(".menu-item--expanded").removeClass("open");
        }
      });
    });
  } else {
    $(function ($) {
      $(
        ".menu-level-0 > .menu-item--expanded > a, .menu-level-0 > .menu-item--expanded > span",
      ).on("click", function (e) {
        e.preventDefault();
        let $parent = $(this).parent();
        let $submenu = $parent.find(".menu-level-1");
        if (!$submenu.find(".back-button").length) {
          const backText =
            drupalSettings.path.currentLanguage === "el" ? "Πίσω" : "Back";
          $submenu.prepend(
            $('<button class="back-button"></button>').text("← " + backText),
          );
        }
        // $(".menu-level-0").hide();
        $submenu.fadeIn();
      });
      $(document).on("click", ".back-button", function () {
        $(this)
          .parent(".menu-level-1")
          .fadeOut(function () {
            $(".menu-level-0").fadeIn();
          });
      });
      $(document).on("click", function (e) {
        if (!$(e.target).closest(".menu-level-0, .menu-level-1").length) {
          $(".menu-level-1").fadeOut();
          $(".menu-level-0").fadeIn();
        }
      });
    });
  }

  $(
    ".navigation-region .menu-main li.menu-item--expanded .menu-level-1>.menu-content>.menu-item--expanded>a",
  ).on("click", function (e) {
    $(this).parent().toggleClass("open-submenu");
    e.preventDefault();
    $(this).parent().siblings().removeClass("open-submenu");
  });

  $("main").css("padding-top", headerHeight);
  $(
    "header .header-container .main-navigation>.menu>.menu-item--expanded>.menu",
  ).css("top", headerHeight);

  $(".burger__wrapper").on("click", function () {
    $("body").toggleClass("open-menu");
    $(".rkpt-search-form").removeClass("active");
    $(".account").removeClass("active");
  });
  if ($(window).width() <= 1024) {
    $(".main-navigation>.menu>.menu-item--expanded>span").on(
      "click",
      function () {
        $(this).siblings(".menu").toggleClass("active");
      },
    );
    $(".user-toggle").on("click", function () {
      $(this).parent().toggleClass("active");
      $("body").removeClass("open-menu");
      $(".rkpt-search-form").removeClass("active");
    });
    $(".main-navigation").css("top", headerHeight);
  }
  if ($(window).width() <= 1024) {
    $(".rkpt-search-form").css("top", headerHeight);
  }

  /* 
  | ----------------------------
  | Facets Region
  | ----------------------------
  */

  $(".sort-item.is-active").each(function () {
    $(this).parent().toggleClass("is-active");
  });

  if ($(window).width() <= 768) {
    $(".block-filters").on("click", function () {
      $(this).parent(".region-sidebar-left").toggleClass("filters-open");
      $(this).siblings(".block-facet--links").toggleClass("facets-open");
      // $(this)
      //   .siblings(".block-facet--links")
      //   .children(".facets-widget-links")
      //   .toggleClass("open");
      $(this)
        .siblings(".block-clear-all-facets-block")
        .toggleClass("facets-open");
    });
  }

  $(document).on("click", ".block-facet--links h2", function () {
    $(this).siblings(".facets-widget-links").toggleClass("open");
  });

  if ($(".block-search-api-sorts h2").length > 0) {
    $(document).on("click", ".block-search-api-sorts h2", function (event) {
      event.stopPropagation();
      $(".block-search-api-sorts").not($(this).parent()).removeClass("open");

      $(this).parent().toggleClass("open");
      // console.log("clicked");
    });
  }

  /* 
  | ----------------------------
  | Search form  
  | ----------------------------
  */
  $(".search-toggle").on("click", function () {
    // $(".region-header-search").toggleClass("active");
    if ($(".region-header-search").hasClass("active")) {
      $(".region-header-search").removeClass("active").addClass("slide-up");
    } else {
      $(".region-header-search").removeClass("slide-up").addClass("active");
    }
    $(".search-results-container").toggleClass("active");
    $(".block-rkpt-search-form-block").toggleClass("active");
    $("body").removeClass("open-menu");
    $(".account").removeClass("active");
  });

  // $("body").on("click", function (event) {
  //   if (
  //     !$(event.target).is(
  //       ".region-header-search, .search-results-container, .search-toggle"
  //     )
  //   ) {
  //   }
  // });

  // $("body").on("click", handleBodyClick);

  // $(document).on("keydown", function (event) {
  //   if (event.key === "Escape") {
  //     handleBodyClick(event);
  //   }
  // });

  // $(".region-header-search, .search-results-container, .search-toggle").on(
  //   "click",
  //   function (event) {
  //     event.stopPropagation();
  //   }
  // );

  // function handleBodyClick(event) {
  //   if (
  //     !$(event.target).is(
  //       ".region-header-search, .search-results-container, .search-toggle"
  //     )
  //   ) {
  //     $(".region-header-search").removeClass("active");
  //     $(".search-results-container").removeClass("active");

  //     $(".rkpt-search-form input").val("");
  //     $("#rkpt-search-results").replaceWith(
  //       '<div id="rkpt-search-results" class="rkpt-search-results"></div>'
  //     );
  //   }
  // }

  /* 
  | ----------------------------
  | Cart block 
  | ----------------------------
  */

  // if ($(".cart-count").html() == "") {
  //   $(".cart-count").css("display", "none");
  // }

  if ($(".cart-container").length > 0) {
    $(document).click(function (e) {
      e.stopPropagation();
      // Check if the clicked element is not within .cart-container or .cart-toggle
      if (
        !$(e.target).closest(".cart-container").length &&
        !$(e.target).closest(".cart-toggle").length
      ) {
        $(".cart").removeClass("active");
      }

      if ($(e.target).closest(".cart-toggle").length) {
        if ($(window).width() >= 768) {
          e.preventDefault();
          $(".cart").addClass("active");
        }
      }
    });
  }

  $(document).on("click", ".cart-close", function (e) {
    e.stopPropagation();
    $(".cart--cart-block.cart").removeClass("active");
  });

  /* 
  | ----------------------------
  | Listing
  | ----------------------------
  */

  // $(function () {
  //   $(".view-content-wrapper__list").on("click", function () {
  //     $(this).addClass("chosen");
  //     $(".view-content-wrapper__grid").removeClass("chosen");
  //     $(this)
  //       .parents(".view-all_terms_elastic_search.view-display-page_1")
  //       .addClass("product-list");
  //   });

  //   $(".view-content-wrapper__grid").on("click", function () {
  //     $(this).addClass("chosen");
  //     $(".view-content-wrapper__list").removeClass("chosen");
  //     $(this)
  //       .parents(".view-all_terms_elastic_search.view-display-page_1")
  //       .removeClass("product-list");
  //   });
  // });

  /* 
  | ----------------------------
  | Product
  | ----------------------------
  // */

  // $(document).ready(function () {
  //   $(
  //     '.product .commerce-order-item-add-to-cart-form .js-form-type-radio input[checked="checked"]'
  //   )
  //     .on("change.symptom", function () {
  //       $(this).siblings("label").addClass("checked");
  //     })
  //     .trigger("change.symptom");
  // });

  // For vertical thumbs
  if ($(".product-top .swiper-thumb-vertical").length) {
    var productSwiper = new Swiper(".product .swiper-thumb-vertical", {
      loop: false,
      spaceBetween: 10,
      slidesPerView: 4,
      watchSlidesProgress: true,
      breakpoints: {
        1024: {
          direction: "vertical",
        },
      },
    });
  }
  // For horizontal thumbs
  if ($(".product-top .swiper-thumb-horizontal").length) {
    var productSwiper = new Swiper(".product .swiper-thumb-horizontal", {
      loop: false,
      spaceBetween: 10,
      slidesPerView: 3,
      allowTouchMove: false,
      breakpoints: {
        0: {
          allowTouchMove: true,
        },
        768: {
          allowTouchMove: false,
        },
      },
    });
  }
  if ($(".product-top .swiper-slider").length) {
    setupSwiper("", ".product-top .swiper-slider", {
      loop: false,
      spaceBetween: 10,
      slidesPerView: 1,
      centeredSlides: true,
      zIndex: 0,
      speed: 600,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
      },
      thumbs: {
        swiper: productSwiper,
      },
    });
  }

  if (
    $(".product-related .related-container .swiper-wrapper").children().length
  ) {
    setupSwiper("", ".product-related .related-container", {
      // slidesPerView: 4,
      // spaceBetween: 16,
      navigation: {
        nextEl: ".swiper-button-next-sec",
        prevEl: ".swiper-button-prev-sec",
      },
      pagination: {
        el: ".swiper-pagination",
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 16,
        },
        370: {
          slidesPerView: 1.5,
          spaceBetween: 16,
        },
        500: {
          slidesPerView: 2,
          spaceBetween: 16,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 32,
        },
        1025: {
          slidesPerView: 4,
          spaceBetween: 32,
        },
      },
      centeredSlides: false,
      watchOverflow: true,
    });
  }

  if (
    $(
      ".product-brand-related .brand-related-container .swiper-wrapper",
    ).children().length
  ) {
    setupSwiper("", ".product-brand-related .brand-related-container", {
      // slidesPerView: 4,
      // spaceBetween: 16,
      navigation: {
        nextEl: ".brand-swiper-button-next-sec",
        prevEl: ".brand-swiper-button-prev-sec",
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 16,
        },
        370: {
          slidesPerView: 1.5,
          spaceBetween: 16,
        },
        500: {
          slidesPerView: 2,
          spaceBetween: 16,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 32,
        },
        1025: {
          slidesPerView: 4,
          spaceBetween: 32,
        },
      },
      centeredSlides: false,
      watchOverflow: true,
    });
  }

  if ($(".recommended-products-block .swiper-wrapper").children().length > 0) {
    setupSwiper("", ".recommended-products-block", {
      slidesPerView: 4,
      spaceBetween: 20,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        0: {
          slidesPerView: 1.3,
        },
        500: {
          slidesPerView: 2.3,
        },
        1025: {
          slidesPerView: 3,
        },
        1300: {
          slidesPerView: 3,
        },
        1450: {
          slidesPerView: 4,
        },
      },
    });
  }

  if ($(".recently-viewed-block .swiper-wrapper").children().length > 0) {
    setupSwiper("", ".recently-viewed-block", {
      slidesPerView: 4,
      spaceBetween: 20,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        0: {
          slidesPerView: 1.3,
        },
        500: {
          slidesPerView: 2.3,
        },
        1025: {
          slidesPerView: 3,
        },
        1300: {
          slidesPerView: 3,
        },
        1450: {
          slidesPerView: 4,
        },
      },
    });
  }

  //Accordion
  if ($(".accordion").length) {
    $(".accordion__item .field__label").on("click", function () {
      $(this).parents(".accordion__item").toggleClass("show");
    });
  }

  //Tabs
  if ($(".tabs").length) {
    $(".tabs__item .field__label").on("click", function () {
      if ($(window).width() > 1024) {
        $(".tabs__item").removeClass("active");
        $(this).parents(".tabs__item").addClass("active");
      } else {
        $(this).parents(".tabs__item").toggleClass("active");
      }
    });
  }

  //Gallery

  $(".swiper.swiper-slider").on("click", ".swiper-slide", function () {
    // $('.dbclick').on('click', function () {
    var pswpElement = document.querySelectorAll(".pswp")[0];
    // build items array
    var items = JSON.parse(drupalSettings.photoswipe);
    // define options (if needed)
    var options = {
      index: parseInt($(this).attr("data-swiper-slide-index"), 10), // start at first slide
      fullscreenEl: false,
      shareEl: false,
      zoomEl: false,
      counterEl: true,
      arrowKeys: true,
      preload: [2, 4],
      closeOnScroll: false,
      spacing: 0.2,
      loop: false,
    };
    // Initializes and opens PhotoSwipe
    var gallery = new PhotoSwipe(
      pswpElement,
      PhotoSwipeUI_Default,
      items,
      options,
    );
    gallery.init();
  });

  /* 
  | ----------------------------
  | Checkout
  | ----------------------------
  */
  if ($(".path-checkout").length) {
    if ($(window).width() > 768) {
      var height = $(".layout-region-checkout-secondary").outerHeight() + 30;
      $(".layout-region-checkout-main").css("min-height", height);

      $("#edit-rkpt-coupon-redemption").on("click", function () {
        var height = $(".layout-region-checkout-secondary").outerHeight() + 30;
        $(".layout-region-checkout-main").css("min-height", height);
      });
    }
  }

  $('input[data-drupal-selector="edit-checkout"]')
    .off()
    .on("click", function () {
      $(".rkpt-loader-wrapper").addClass("active");
    });

  /* 
  | ----------------------------
  | Swiper setup
  | ----------------------------
  */

  function setupSwiper(width, element, options) {
    // breakpoint where swiper will be destroyed
    var breakpoint = window.matchMedia("(min-width:" + width + ")");

    // keep track of swiper instances to destroy later
    var mySwiper;

    var breakpointChecker = function () {
      // if larger viewport and multi-row layout needed
      if (breakpoint.matches) {
        // clean up old instances and inline styles when available
        if (mySwiper !== undefined) {
          mySwiper.destroy(true, true);
          // or/and do nothing
          return;
        }

        // else if a small viewport and double column layout needed
      } else {
        // fire small viewport version of swiper
        return enableSwiper();
      }
    };

    var enableSwiper = function () {
      mySwiper = new Swiper(element, options);
    };

    // keep an eye on viewport size changes
    breakpoint.addListener(breakpointChecker);

    // kickstart
    breakpointChecker();
  }

  // var messagesBanner = new Swiper(".messages-swiper", {
  //   slidesPerView: 3,
  //   spaceBetween: 15,
  //   pagination: {
  //     clickable: true,
  //   },
  //   breakpoints: {
  //     0: {
  //       slidesPerView: 1,
  //       spaceBetween: 15,
  //     },
  //     768: {
  //       slidesPerView: 2,
  //       spaceBetween: 10,
  //     },
  //   },
  // });

  /* 
  | ----------------------------
  | Home components
  | ----------------------------
  */

  $(".swiper-hero").each(function () {
    if ($(this).children(".swiper-wrapper").length) {
      var heroSwiper = new Swiper(this, {
        slidesPerView: 1,
        watchSlidesProgress: true,
        loop: true,
        spaceBetween: 10,
        // autoplay: {
        //   delay: 2700,
        //   pauseOnMouseEnter: true,
        // },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });
    }
  });

  $(".carousel-slide").each(function () {
    var $carousel = $(this).closest(".carousel-slider");
    var totalItemsNumber = $carousel.data("attr");

    if ($(this).children(".swiper-wrapper").length > totalItemsNumber) {
      var categorySwiper = new Swiper(this, {
        slidesPerView: totalItemsNumber,
        watchSlidesProgress: true,
        loop: true,
        spaceBetween: 30,
        navigation: {
          nextEl: ".product-slider.swiper-button-next",
          prevEl: ".product-slider.swiper-button-prev",
        },
        pagination: {
          el: ".product-slider.swiper-pagination",
          clickable: true,
        },
        breakpoints: {
          0: {
            slidesPerView: 1.3,
            spaceBetween: 20,
          },
          500: {
            slidesPerView: 2.2,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 2.5,
            spaceBetween: 30,
          },
          1025: {
            slidesPerView: totalItemsNumber,
            spaceBetween: 30,
          },
        },
      });
    } else {
      var categorySwiper = new Swiper(this, {
        slidesPerView: totalItemsNumber,
        watchSlidesProgress: true,
        spaceBetween: 30,
        navigation: {
          nextEl: ".product-slider.swiper-button-next",
          prevEl: ".product-slider.swiper-button-prev",
        },
        pagination: {
          el: ".product-slider.swiper-pagination",
          clickable: true,
        },
        breakpoints: {
          0: {
            slidesPerView: 1.3,
            spaceBetween: 20,
          },
          500: {
            slidesPerView: 2.2,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 2.5,
            spaceBetween: 30,
          },
          1025: {
            slidesPerView: totalItemsNumber,
            spaceBetween: 30,
          },
        },
      });
    }
  });

  if ($(window).width() <= 768) {
    if ($(".swiper-brands .swiper-wrapper").length) {
      var productSwiper = new Swiper(".swiper-brands", {
        slidesPerView: 6,
        spaceBetween: 24,
        navigation: {
          nextEl: ".brands.swiper-button-next",
          prevEl: ".brands.swiper-button-prev",
        },
        breakpoints: {
          0: {
            slidesPerView: 1.5,
            spaceBetween: 20,
          },
          400: {
            slidesPerView: 2.5,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 2.5,
            spaceBetween: 24,
          },
        },
      });
    }
  }

  $(".promoted-products").each(function () {
    if ($(this).children(".swiper-wrapper").length) {
      var productSwiper = new Swiper(this, {
        slidesPerView: 4,
        watchSlidesProgress: true,
        spaceBetween: 32,
        navigation: {
          nextEl: ".swiper-button-next-sec",
          prevEl: ".swiper-button-prev-sec",
        },
        breakpoints: {
          0: {
            slidesPerView: 1.5,
            spaceBetween: 22,
          },

          768: {
            slidesPerView: 2.5,
            spaceBetween: 22,
          },
          1025: {
            slidesPerView: 3,
            spaceBetween: 32,
          },
          1300: {
            slidesPerView: 4,
            spaceBetween: 32,
          },
        },
      });
    }
  });

  /* 
  | ----------------------------
  | Facets Region
  | ----------------------------
  */

  $(".sort-item.is-active").each(function () {
    $(this).parent().toggleClass("is-active");
  });

  if ($(".facets-widget-checkbox h3").length > 0) {
    $(document).on("click", ".facets-widget-checkbox h3", function (event) {
      event.stopPropagation();
      $(".facets-widget-checkbox").not($(this).parent()).removeClass("open");

      $(this).parent().toggleClass("open");
    });
  }

  if (
    $(".facets-widget-checkbox").length > 0 ||
    $(".sortby__wrapper").length > 0
  ) {
    $(document).on("click", function (e) {
      e.stopPropagation();
      if (!$(e.target).closest(".facets-widget-checkbox").length) {
        $(".facets-widget-checkbox").removeClass("open");
      }
      if (!$(e.target).closest(".sortby__wrapper").length) {
        $(".sortby__wrapper").removeClass("open");
      }
    });
  }

  $(".view-filters h2").on("click", function () {
    $(this).toggleClass("active");
    $(".region__wrapper").toggleClass("view");
  });

  /* 
  | ----------------------------
  | Stores
  | ----------------------------
  */

  $(".opening-hours .field-field-opening-hours .field__label").on(
    "click",
    function () {
      $(this).siblings(".field__item").toggleClass("show");

      $(".opening-hours .field-field-opening-hours .field__item")
        .not($(this).siblings(".field__item"))
        .removeClass("show");
    },
  );

  /* 
  | ---------------------------------
  | Taxonomy term list view cookie
  | ---------------------------------
  */

  Drupal.behaviors.themeCookies = {
    attach: function (context, settings) {
      const $viewContainer = $(
        ".view-all_terms_elastic_search.view-display-page_1, .view-search_page.view-display-page_1",
        context,
      );

      if (
        document.cookie
          .split("; ")
          .find((row) => row.startsWith("view-mode="))
          ?.split("=")[1] === "list"
      ) {
        $viewContainer.addClass("product-list");
        $(".view-content-wrapper__list", context).addClass("chosen");
        $(".view-content-wrapper__grid", context).removeClass("chosen");
      } else {
        $(".view-content-wrapper__grid", context).addClass("chosen");
      }

      if (
        !$(".view-content-wrapper__list", context).hasClass(
          "js-view-toggle-bound",
        )
      ) {
        $(".view-content-wrapper__list", context)
          .addClass("js-view-toggle-bound")
          .on("click", function () {
            $(this).addClass("chosen");
            $(".view-content-wrapper__grid", context).removeClass("chosen");
            $viewContainer.addClass("product-list");

            document.cookie =
              "view-mode=list; max-age=" + 7 * 24 * 60 * 60 + "; path=/";
          });
      }

      if (
        !$(".view-content-wrapper__grid", context).hasClass(
          "js-view-toggle-bound",
        )
      ) {
        $(".view-content-wrapper__grid", context)
          .addClass("js-view-toggle-bound")
          .on("click", function () {
            $(this).addClass("chosen");
            $(".view-content-wrapper__list", context).removeClass("chosen");
            $viewContainer.removeClass("product-list");

            document.cookie =
              "view-mode=; expires=Mon, 15 Nov 1993 00:00:00 UTC; path=/";
          });
      }
    },
  };

  Drupal.behaviors.retailPriceToggle = {
    attach: function (context, settings) {
      const $priceSwitchInput = $(".prices-switch--input", context);

      if (
        document.cookie
          .split("; ")
          .find((row) => row.startsWith("retail-price-mode="))
          ?.split("=")[1] === "show-retail-price"
      ) {
        $("body").addClass("show-retail-price");
      } else {
        $("body").removeClass("show-retail-price");
      }

      $priceSwitchInput.prop(
        "checked",
        $("body").hasClass("show-retail-price"),
      );

      if (!$priceSwitchInput.hasClass("js-price-toggle-bound")) {
        $priceSwitchInput
          .addClass("js-price-toggle-bound")
          .on("change", function () {
            $("body").toggleClass("show-retail-price");

            if ($("body").hasClass("show-retail-price")) {
              document.cookie =
                "retail-price-mode=show-retail-price; max-age=" +
                7 * 24 * 60 * 60 +
                "; path=/";
            } else {
              document.cookie =
                "retail-price-mode=; expires=Mon, 15 Nov 1993 00:00:00 UTC; path=/";
            }
          });
      }
    },
  };

  Drupal.behaviors.vatToggle = {
    attach: function (context, settings) {
      const $vatSwitchInput = $(".view-header .vat-switch--input", context);
      const $productVatSwitchInput = $(
        ".product.full .vat-switch--input",
        context,
      );

      if (
        document.cookie
          .split("; ")
          .find((row) => row.startsWith("vat-mode="))
          ?.split("=")[1] === "show-vat"
      ) {
        $("body").addClass("show-vat");
      } else {
        $("body").removeClass("show-vat");
      }

      $vatSwitchInput.prop("checked", $("body").hasClass("show-vat"));

      if (!$vatSwitchInput.hasClass("js-vat-toggle-bound")) {
        $vatSwitchInput
          .addClass("js-vat-toggle-bound")
          .on("change", function () {
            $("body").toggleClass("show-vat");

            if ($("body").hasClass("show-vat")) {
              document.cookie =
                "vat-mode=show-vat; max-age=" + 7 * 24 * 60 * 60 + "; path=/";
            } else {
              document.cookie =
                "vat-mode=; expires=Mon, 15 Nov 1993 00:00:00 UTC; path=/";
            }
          });
      }

      $productVatSwitchInput.each(function () {
        if (!$(this).hasClass("js-vat-toggle-bound")) {
          $(this)
            .addClass("js-vat-toggle-bound")
            .on("change", function () {
              $("body").toggleClass("show-vat-product");
            });
        }
      });
    },
  };

  //Dashboard
  var inactiveCartField = $(
    ".view-mycarts .view-content .views-row .views-field-rkpt-active-cart-field .field-content a",
  );

  var inactiveCart = $(inactiveCartField).closest(".views-row");
  $(inactiveCart).addClass("inactive");

  //ESPA WCAG
  $(function () {
    $(".rkpt-search-form .form-actions input").css({
      color: "#000",
      "background-color": "rgb(255 255 255 / 0%)",
    });

    $(
      ".view-commerce_cart_form .views-field-remove-button .delete-order-item",
    ).css({
      color: "#000",
      "background-color": "rgb(255 255 255 / 0%)",
    });

    $(
      ".view-commerce_cart_form .views-field-edit-quantity input.form-number, " +
        ".view-user_cart_form .views-field-edit-quantity input.form-number",
    ).each(function () {
      var id = $(this).attr("id");
      if (id) {
        $(this).attr("aria-label", id);
      }
    });

    var closed_manually = false;

    $(document).on("click", ".espa-banner .close-banner", function (e) {
      e.preventDefault();
      closed_manually = true;
      $(this)
        .parent()
        .slideUp(300, function () {});
    });
  });
})(jQuery, Drupal, drupalSettings);
